import ActionGroup from '../../../layout/forms/action-group';
import RichTranslation from '@blueshift-ui/i18n/dist/components/rich-translation';
import { TrackedButton } from '@blueshift-ui/analytics';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

function UpgradeToMembershipMessage() {
  const { loading: loadingRichTranslation, translate: richTranslate } = useTranslation(
    'pause_membership.upgrade_to_membership',
    { rich: true }
  );
  const { loading: loadingTranslation, translate } = useTranslation(
    'pause_membership.upgrade_to_membership'
  );

  if (loadingTranslation || loadingRichTranslation) {
    return null;
  }

  return (
    <>
      <h1>{translate('title')}</h1>

      <RichTranslation i18nKey="content" translator={richTranslate} />

      <ActionGroup>
        <TrackedButton
          href={`https://www.${process.env.VITE_DOMAIN_NAME}/membership`}
          id="upgrade_to_membership_button"
        >
          {translate('button')}
        </TrackedButton>
      </ActionGroup>
    </>
  );
}

export default UpgradeToMembershipMessage;
